import { Action } from '@ngrx/store';
import { DependantDoctor } from 'src/app/model/ngrx/health-records.model';

export const ADD_DEP_HEALTH_RECORDS = '[DEP_HEALTH_RECORDS] Add';
export const REMOVE_DEP_HEALTH_RECORDS = '[DEP_HEALTH_RECORDS] Remove';

// AddPersonalDetails
export class AddDepHealthRecords implements Action {
    readonly type = ADD_DEP_HEALTH_RECORDS;

    constructor(public payload: DependantDoctor) { }
}
// RemovePersonalDetails
export class RemoveDepHealthRecords implements Action {
    readonly type = REMOVE_DEP_HEALTH_RECORDS;

    constructor(public payload: number) { }
}

export type DepHealthRecordActions = AddDepHealthRecords | RemoveDepHealthRecords;
